import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { Competency, CompetencySettingType, QuestionTypesWithCompetency } from '@/models/competency/competency';
import { QuestionType } from '@/models/evalSetting/question-type';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import { Trend } from '@/models/trend/trend';
import { InterviewNaviCompetency } from '@/models/interview-navi/competency';
import { lgateService } from '@/service/api/lgate.service';
import { growingPurposeService } from '@/service/api/growing-purpose.service';
import { Destination } from '@/models/jgrow/destination';
import { LgatePreLinkage } from '@/models/lgate/lgate-pre-linkage';
import { GEnum } from '@/constants/enum.defination';
import { Empty } from '@/models/core/empty';

export interface ILgateState {
  preLinkageData: LgatePreLinkage;
  preLinkage: boolean;
}
@Module({ dynamic: true, store, name: 'lgateModule', namespaced: true })
class LgateModule extends VuexModule implements ILgateState {
  preLinkageData: LgatePreLinkage = new LgatePreLinkage();
  preLinkage: boolean = false;

  @Mutation
  setPreLinkageData(value: LgatePreLinkage) {
    this.preLinkageData = value;
    this.preLinkage = true;
  }

  @Mutation
  setPreLinkage(value: boolean) {
    this.preLinkage = value;
  }

  @Mutation
  clear() {
    this.preLinkage = false;
  }


  /**
   * L-Gate連携ボタン押下での差分確認
   */
  @Action({ rawError: true })
  async requestPreLinkage() {
    const result: LgatePreLinkage = await lgateService.requestPreLinkage();
    this.setPreLinkageData(result);
  }

  /**
   * L-Gate連携実行
   */
  @Action({ rawError: true })
  async requestLinkage() {
    const result: Empty = await lgateService.requestLinkage();
    this.setPreLinkage(false);
    return;
  }
}

export const lgateModule = getModule(LgateModule);
